import React from 'react';

import { alpha, Typography } from '@mui/material';
import clsx from 'clsx';
import { Apollo } from 'src/gql/generated';
import { getTypographyForSx, themeV5 } from 'src/theme';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles<{ status: Apollo.WorkflowStatus }>()((theme, { status }) => ({
  statusPill: {
    backgroundColor: getWorkflowStatusChipColor(status),
    borderRadius: 3,
    padding: theme.spacing(0.5, 1),
    width: 'fit-content',
  },
  statusText: {
    ...getTypographyForSx(theme.typography.body1),
    color: getWorkflowStatusChipTextColor(status),
    fontSize: 10,
    fontWeight: 600,
  },
}));

interface WorkflowStatusChipProps extends React.HTMLAttributes<HTMLElement> {
  status: Apollo.WorkflowStatus;
}

export function WorkflowStatusChip({ className, status }: WorkflowStatusChipProps): JSX.Element {
  const { classes } = useStyles({ status });
  const statusText = getStatusChipText(status);

  return (
    <div className={clsx(classes.statusPill, className)}>
      <Typography className={classes.statusText}>{statusText}</Typography>
    </div>
  );
}

export function getWorkflowStatusChipColor(status: Apollo.WorkflowStatus): string {
  switch (status) {
    case Apollo.WorkflowStatus.Running:
      return 'rgba(0, 108, 240, 0.2)';
    case Apollo.WorkflowStatus.Completed:
      return alpha(themeV5.appColors.avatarLime, 0.2);
    case Apollo.WorkflowStatus.Template:
      return themeV5.appColors.iconsType;
  }
}

export function getWorkflowStatusChipTextColor(status: Apollo.WorkflowStatus): string {
  switch (status) {
    case Apollo.WorkflowStatus.Running:
      return themeV5.palette.primary.main;
    case Apollo.WorkflowStatus.Completed:
      return themeV5.appColors.avatarLime;
    case Apollo.WorkflowStatus.Template:
      return themeV5.palette.common.white;
  }
}

export function getStatusChipText(status: Apollo.WorkflowStatus): string {
  switch (status) {
    case Apollo.WorkflowStatus.Completed:
      return 'Completed';
    case Apollo.WorkflowStatus.Running:
      return 'Running';
    case Apollo.WorkflowStatus.Template:
      return 'Template';
  }
}
